import 'rc-time-picker/assets/index.css';

import React, { Component } from 'react';
import moment from 'moment';
import TimePicker from 'rc-time-picker';

const parseTime = (val) => {
  if (!val) return null;
  if (moment.isMoment(val)) return val.isValid() ? val : null;
  const parsed = moment(val, ['HH:mm', 'H:mm', 'HH:mm:ss', 'H:mm:ss', 'h:mm a', 'h:mm A']);
  return parsed.isValid() ? parsed : null;
};

class WidgetTimePicker extends Component {
  onChange = (value) => {
    if (!value) {
      this.props.onChange(undefined);
      return;
    }
    this.props.onChange(value.format('HH:mm'));
  };

  render() {
    const { use24Hours, ...extraOptions } = this.props.options || {};
    const format = use24Hours ? 'HH:mm' : 'h:mm a';

    const rawValue =
      this.props.value !== undefined && this.props.value !== null && this.props.value !== ''
        ? this.props.value
        : this.props.schema && this.props.schema.default;

    const timeValue = parseTime(rawValue);

    return (
      <TimePicker
        showSecond={false}
        value={timeValue || undefined}
        onChange={this.onChange}
        format={format}
        disabled={
          this.props.disabled ||
          (this.props.schema && (this.props.schema.disable || this.props.schema.disabled))
        }
        use12Hours={!use24Hours}
        inputReadOnly
        {...extraOptions}
      />
    );
  }
}

export default WidgetTimePicker;



// WEBPACK FOOTER //
// ./src/lib/widget-timePicker.js